import React, { useState, useEffect } from 'react'

function Kontakt() {
  const [pageContent, setPageContent] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchKontaktPage = async () => {
      try {
        const response = await fetch('/wp-json/wp/v2/pages?slug=kontakt&_embed')
        const data = await response.json()

        if (data.length > 0) {
          const page = data[0]
          setPageContent({
            title: page.title.rendered,
            content: page.content.rendered,
            featuredImage: page._embedded?.['wp:featuredmedia']?.[0]?.source_url
          })
        }
        setLoading(false)
      } catch (error) {
        console.error('Error fetching Kontakt page:', error)
        setLoading(false)
      }
    }

    fetchKontaktPage()
  }, [])

  useEffect(() => {
    if (pageContent) {
      // Substack widget configuration in code
      window.CustomSubstackWidget = {
        substackUrl: "darabrexendorf.substack.com",
        placeholder: "example@gmail.com",
        buttonText: "Subscribe",
        theme: "custom",
        colors: {
          primary: "#B0AFE1",
          input: "#F1F1F1",
          email: "#000000",
          text: "#000000",
        }
      }

      // Script loading logic
      const script = document.createElement('script')
      script.src = "https://substackapi.com/widget.js"
      script.async = true
      document.body.appendChild(script)
    }
  }, [pageContent])

  if (loading) return <div className="loading">Loading...</div>

  return (
    <div className="kontakt-page">
      <h1 className="page-title">{pageContent.title}</h1>
      
      <div 
        className="kontakt-content"
        dangerouslySetInnerHTML={{ __html: pageContent.content }}
      />
      
      {pageContent.featuredImage && (
        <div className="kontakt-featured-image">
          <img src={pageContent.featuredImage} alt={pageContent.title} />
        </div>
      )}

      {/* Substack Embed Container */}
      <div id="custom-substack-embed" />
    </div>
  )
}

export default Kontakt